<template>
    <pt-gene-lab-order-table ref="table" class="pt-gene-lab-order-table__withData" @get-data-list="getDataList" :page-size="pageSize"
  :total-number="totalNumber" :tableData="tableData" @updateSelectedData="updateSelectedData" v-loading="loading"  v-bind="$attrs" v-on="$listeners" :current-page="currentPage" :isOutside="isOutside" :isAddPageToRouter="isAddPageToRouter" :showCopy="showCopy">
      <template slot-scope="scope">
        <el-button type="text" @click="goDetail(scope.row.orderId, scope.row)">详情
				</el-button>
        <el-button type="text" @click="goEdit(scope.row.orderId, scope.row)" v-if="HAS_PERM_LAB_EDIT_ORDER">编辑
				</el-button>
        <!-- <el-button type="text" >下载报告</el-button> -->

          <!-- <el-button type="text" v-if="scope.row.reportOssUrl">
              <a :href="$privateResourcesUrl+scope.row.reportOssUrl" target="_blank" :class="$style['view-report']">下载报告</a>
              </el-button> -->

      </template>
    </pt-gene-lab-order-table>
</template>

<script>
import PtGeneLabOrderTable from './index'
// import { dataExport } from 'utils/formUtils'
import { hasPermissions } from 'utils/permissions'
const PERM_LAB_EDIT_ORDER = 'PERM_LAB_EDIT_ORDER'
export default {
  name: 'pt-gene-lab-order-table__withData',
  components: {
    'pt-gene-lab-order-table': PtGeneLabOrderTable
  },
  computed: {
    HAS_PERM_LAB_EDIT_ORDER () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_LAB_EDIT_ORDER)
    }
  },
  data () {
    return {
      pageSize: 50,
      totalNumber: 0,
      page: 0,
      isChangePage: false,
      tableData: [],
      currentParams: JSON.stringify(this.params) !== '{}' ? this.params : {},
      currentPage: 0,
      currentFuzzy: this.isFuzzy,
      isOutside: false,
      loading: false
    }
  },
  props: {
    // 传入的参数
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isLot: {
      type: Boolean,
      default: false
    },
    isFuzzy: {
      type: Boolean,
      default: false
    },
    packageType: {
      type: String,
      default: ''
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    isAddPageToRouter: {
      type: Boolean,
      default: true
    },
    showCopy: {
      type: Boolean,
      default: false
    }
  },
  inheritAttrs: false,
  watch: {
    page (val, old) {
      if (val !== old) {
        // 每次请求时置空数据，重新渲染，使页面回到顶部的问题
        this.tableData = []
        this.isChangePage = true
      }
    },
    isFuzzy (val) {
      this.currentFuzzy = val
    },
    params: {
      handler: function (val, old) {
        if (this.isAddPageToRouter && val !== old) {
          if (!this.isFromRouter) {
            this.currentParams = val
            this.resetPage()
          } else {
            this.isOutside = true
            this.currentParams = val
            this.getDataList(this.$route.query.page - 1)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    // isDisabled (data) {
    //   return data.nextOrderAction !== 'LAB_SAMPLES_RECEIVED'
    // },
    resetPage () {
      this.$refs.table.resetPage()
    },
    goEdit (id) {
      this.$router.push(`/lab-order-form/true/${id}`)
    },
    buildFilterParams (params = {}, page = 0, size) {
      if (Object.keys(params).length) {
        if (page || page === 0) {
          params.pageableParam['page'] = page
        }
        params.pageableParam['size'] = size || this.pageSize
        params.needHistoryOrders = true
        if (this.packageType) {
          params.packageProductionType = this.packageType
        }
        return params
      } else {
        return {
          // methodIds: [],
          needActionTaskInfo: true,
          pageableParam: { page: page, size: size || this.pageSize },
          productIds: [],
          statusTime: [{ startTime: '', endTime: '', orderStatus: 'COMPLETED' }],
          needHistoryOrders: true,
          packageProductionType: this.packageType
          // upStreamOrganizationIds: []
        }
      }
    },
    getDataList (page, next, size) {
      this.page = page
      let data = {}
      this.$nextTick(_ => {
        if (this.currentParams && this.currentParams.pageableParam && !this.isChangePage) {
          data = this.buildFilterParams(this.currentParams, null, size)
          this.currentPage = 0
        } else {
          this.currentPage = page + 1
          data = this.buildFilterParams(this.currentParams, page, size)
        }
        let api = this.isLot ? 'excludeTask' : 'getLabOrderList'
        if (this.isLot) {
          api = this.$route.query.isAdult ? 'AdultexcludeTask' : 'excludeTask'
        } else {
          api = 'getLabOrderList'
        }
        if (this.currentFuzzy) {
          api = this.$route.query.isAdult ? 'adultOrderFuzzy' : 'labOrderFuzzy'
        }
        if (!next) {
          this.loading = true
        }
        this.$store.dispatch(api, data).then(res => {
          if (next) {
            next(res.data)
          }
          this.loading = false
          this.tableData = res.data
          // console.log('res', res)
          this.totalNumber = res.totalNumber
          this.$emit('getAllSize', this.totalNumber)
          this.isChangePage = this.isChangePage && false
        }).catch(err => {
          this.$refs.table.showReTry()
          this.loading = false
          this.$message.error(err)
        })
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}, isFuzzy = false) {
      if (isFuzzy) {
        this.currentFuzzy = true
      }
      this.currentParams = params
      if (!this.isFromRouter) {
        this.$refs.table.resetPage()
      } else {
        this.$refs.table.reload()
      }
    },
    updateSelectedData (datas) {
      this.$emit('updateSelectedData', datas)
    },
    goDetail (orderId) {
      // 跳转详情页面时直接将当前数据通过'value'传递，避免再次加载数据的请求。
      this.$router.push({ name: 'lab-order-detail', params: { id: orderId } })
    },
    exportExcel (params) {
      this.$store.dispatch('exportLabOrders', params).then(message => {
        // dataExport(res)
        this.$message.success(message)
        this.$refs.table.clearSelection()
        this.$emit('exportSuccess')
      }).catch(err => {
        this.$emit('exportSuccess')
        this.$message(err || '导出失败')
      })
    },
    downReports (params) {
      this.$store.dispatch('downloadReport', params).then(message => {
        // dataExport(res)
        this.$message.success(message)
        this.$refs.table.clearSelection()
        this.$emit('downSuccess')
      }).catch(err => {
        this.$message(err || '导出失败')
        this.$emit('downSuccess')
      })
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    }
  }
}
</script>
<style module lang="less">
.view-report{
text-decoration:none
}
</style>
